/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".email-success[_ngcontent-%COMP%]{background-color:#01aaad;color:#fff;text-align:center;border-radius:5px;margin:5px}.email-error[_ngcontent-%COMP%]{background-color:#d45555;color:#fff;text-align:center;border-radius:5px;margin:5px}"];
export { styles as styles };
